import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { setTeacherCredentials } from '../../slices/teachers/authTeacherSlice';
import { useManagePaymentsMutation, useGetPaymentBalanceQuery } from '../../slices/teachers/teacherApiPayment';
import { stripeCurrencyFormatter } from '../../utils/helpers';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';

const TeacherRevenue = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [balance, setBalance] = useState({ pending: [] });
  const [loading, setLoading] = useState(false);

  const { data, isLoading, error } = useGetPaymentBalanceQuery();

  const [managePayments, {  error: newerror }] = useManagePaymentsMutation();

  const { teacherInfo } = useSelector((state) => state.authTeacher);

  useEffect(() => {
    if(!teacherInfo) {
        navigate('/teacherlogin')
    }
  }, [navigate, teacherInfo])

  useEffect(() => {
    if(!teacherInfo?.isPaymentSetup) {
        navigate('/teachersetuppayment')
    }
  }, [navigate, teacherInfo]);

  useEffect(() => {
    if (data) {
      setBalance(data)
    }
  }, [data]);

  const managePay = async (e) => {
    e.preventDefault()
    try {
        setLoading(true);
        const res = await managePayments();
        window.location.href = res.data;
    } catch (error) {
        setLoading(false);
        toast.error('Unable to access payout settings. Try later.');  
    }
  }

  return (
    <div>
      <TeacherNavbar />
      <div className="main-content" id="panel">
      <TeacherHeader /><br /><br /><br /><br /><br />
      <div className="container-fluid mt--6">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">  
              <div className="card-wrapper profileCard">
                <div className="card"> <br />
                    <h2 className="centerTitle tittleColor4 ">
                    <span className='tittleColor'>
                        Revenue Report
                    </span>
                        </h2>
                    <p className='text-info text-center small'>
                    Ask to Learn partners with stripe to transfer earnings to your bank account <br />
                      You get paid directly from stripe to your bank account every 30 days.
                    </p><br /><br /><br />
                    <div className="card-body">
                      <hr />
                      <div className="row">
                      <div className="offset-xl-2 col-xl-4">  
                        <h5 className="centerTitle tittleColor pending3">
                        <span className='tittleColor'>Pending Balance</span>
                        </h5>
                      </div>
                      <div className="col-xl-4">  
                      <h5 className="centerTitle tittleColor4 pending4">
                      <span className='tittleColor'>
                      {balance.pending &&
                        balance.pending.map((bp, i) => (
                          <span key={i} className="float-right">
                            {stripeCurrencyFormatter(bp)}
                          </span>
                      ))}
                      </span>
                      </h5>
                      </div>
                      </div>
                      <hr />
                      {!loading ? (
                        <>   
                        <Button type='submit' onClick={managePay} variant='success' className=' btn btn-primary btn-lg rounded-pill bg-gradient-primary setPay'>
                            Manage Payouts Account
                        </Button><br /> 
                        </>                    
                          ) : (                    
                        <Loader />
                        )}
                      <p className=" text-info text-center small tittleColor">
                      You will be redirected to stripe to manage your payment account.
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherRevenue
